import { Container, Header, Icon, SpaceBetween, TextContent } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../hooks/localizedText';

export function AmbassadorOffboardingConfirmation() {
  const { t } = useLocalizedText(['ambassadors', 'translation']);

  return (
    <Container>
      <SpaceBetween direction="vertical" size="s" alignItems="center">
        <Icon name="status-positive" size="large" variant="success" />
        <Header data-testid="ambassador-offboarding-confirmation-header" variant="h1">
          {t('ambassadorOffboarding.confirmation')}
        </Header>
        <TextContent>
          <p>{t('ambassadorOffboarding.weAppreciate')}</p>
        </TextContent>
      </SpaceBetween>
    </Container>
  );
}
